import { useEffect, useState } from 'react';

import { useMediaCenterCategoriesContext } from 'hb-react/frontoffice/apps/MediaCenter/contexts/MediaCenterCategoriesContext';

import { makeTagsFromCategories } from '../utils/rendererUtils';

export const useCategories = () => {
  const { categories } = useMediaCenterCategoriesContext();
  const [tags, setTags] = useState();

  useEffect(() => {
    if (categories) {
      setTags(makeTagsFromCategories(categories));
    }
  }, [categories]);

  return tags;
};
